import { Component, Input, OnInit } from '@angular/core';
import { Globals } from 'app/_globals';
import { NotificationService } from 'app/_services/notification.service';
import { ReportsService } from 'app/_services/reports.service';
import { utils as xlsx_utils, writeFile as xlsx_writeFile } from 'xlsx';

@Component({
  selector: 'app-worker-competency-and-training-report',
  templateUrl: './worker-competency-and-training-report.component.html',
})
export class WorkerCompetencyAndTrainingReportComponent implements OnInit {
  @Input() siteOwnerId: any;

  constructor(
    private reportsService: ReportsService,
    private notificationService: NotificationService,
  ) {
  }

  ngOnInit() {
  }

  public generateReport() {
    this.reportsService.getWorkerCompetencyAndTrainingReport(this.siteOwnerId).subscribe((data: any) => {
      this.processDataIntoDocument(data);
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Could not fetch report data');
    });
  }

  private processDataIntoDocument(data) {
    const { workers, allRelevantCompetencies, allRelevantCourses } = data;

    // Define headers for the spreadsheet
    const headers = allRelevantCourses.map(c => c.name).concat(allRelevantCompetencies.map(c => c.name));
    headers.unshift('First Name', 'Last Name', 'Contractor');


    // Create an array of objects containing the data for each worker
    const workerData = workers.map(worker => {
      const rowData = {};

      allRelevantCourses.forEach(headingCourse => {
        const dataCourse = worker.workerUserCourses.find(course => course.courseName === headingCourse.name);
        rowData[headingCourse.name] = dataCourse ? new Date(dataCourse.expiryDate) : null;
      });

      allRelevantCompetencies.forEach(headingComp => {
        const dataComp = worker.competencies.find(comp => comp.competencyName === headingComp.name);
        rowData[headingComp.name] = dataComp ? new Date(dataComp.expiryDate) : null;
      });

      rowData['First Name'] = worker.firstName;
      rowData['Last Name'] = worker.lastName;
      rowData['Contractor'] = worker.contractor;
      return rowData;
    });

    // Create a new workbook and worksheet
    const workbook = xlsx_utils.book_new();
    const worksheet = xlsx_utils.json_to_sheet(workerData, { header: headers, cellDates: true });

    // Format the columns
    var wscols = headers.map((header, index) => {
      if (index < 3) {
        return { width: 20 }; // set width of first 3 columns
      } else {
        return { width: 20, z: "yyyy-mm-dd" }; // date format the rest
      }
    });
    worksheet["!cols"] = wscols;
    worksheet['!autofilter'] = { ref: worksheet['!ref'] };

    xlsx_utils.book_append_sheet(workbook, worksheet, 'Workers');
    const today = new Date();
    xlsx_writeFile(workbook, `Worker Report ${today.toLocaleDateString()}.xlsx`);
  }
}
